// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"674baa02","239":"6a33ba12","732":"7d6b3d5b"}[chunkId] + ".chunk.js";
};